import {
    Component,
    OnInit,
    AfterViewChecked,
    ChangeDetectorRef,
    ViewEncapsulation,
    Inject,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { merge, Observable, Subject, forkJoin } from 'rxjs';
import { AuthenticationService, DropdownsService } from 'app/services';
import {
    startWith,
    switchMap,
    tap,
    takeUntil,
    debounceTime,
} from 'rxjs/operators';
import { GlobalFuntions } from 'app/_helpers';
import * as _ from 'lodash';
import { PropertiesService } from 'app/services/properties.service';
import { AttachmentsService } from 'app/services/attachments.service';
import { ComposeEmailsService } from 'app/services/compose-emails.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { map } from 'lodash';
import { fuseAnimations } from '@fuse/animations';
import { PreviewEmailComponent } from 'app/directives/compose-email/preview-email/preview-email.component';
import { QuickAddComponent } from 'app/main/master-data/accounts/quick-add/quick-add.component';
import { PdfListDialogComponent } from 'app/directives/pdf-templates/pdf-list-dialog/pdf-list-dialog.component';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { GLOBALS } from 'app/config/globals';
@Component({
    selector: 'app-properties-print-email',
    templateUrl: './properties-print-email.component.html',
    styleUrls: ['./properties-print-email.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PropertiesPrintEmailComponent implements OnInit, AfterViewChecked {
    pdf: UntypedFormGroup;
    values: any;
    user: any;
    showExtraToFields: boolean;
    emails: string[] = [];
    emailsCtrl = new UntypedFormControl('');
    templatesCtrl = new UntypedFormControl('');
    filteredEmials: Observable<string[]>;
    filteredTemplates: Observable<any>;
    properties: any;
    filter = {} as any;
    searching: boolean;
    public propertySearch = new Subject<string>();
    sign = '';
    attachments: string[] = [];
    separatorKeysCodes: number[] = [ENTER, COMMA];

    private _unsubscribeAll: Subject<any>;
    accountSearch$ = new Subject<string>();
    accounts = [] as any;
    loadingAccounts = false;
    activeEditor: any;
    emailSearch$ = new Subject<string>();
    emailsData = [] as any;
    loadingEmails = false;
    public tinyMc = GLOBALS.tinyMce; // To use centralized tinyMce

    downloadFiles = {
        urls: [],
        names: [],
    } as any;
    currentLang: string;

    @ViewChild('emailInput', { static: false })
    emailInput: ElementRef<HTMLInputElement>;
    constructor(
        public dialogRef: MatDialogRef<PropertiesPrintEmailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: UntypedFormBuilder,
        private cdRef: ChangeDetectorRef,
        private _authenticationService: AuthenticationService,
        private router: Router,
        private _dropdownsService: DropdownsService,
        private _globalFunctions: GlobalFuntions,
        private _propertiesService: PropertiesService,
        private _attachmentsService: AttachmentsService,
        public _composeEmailsService: ComposeEmailsService,
        private _snackBar: MatSnackBar,
        private _translateService: TranslateService,
        private _matDialog: MatDialog
    ) {
        this.tinyMc.setup = (editor) => {
            editor.on('init', (e) => {
                this.activeEditor = editor;
            });
        };
        this.currentLang =
            this._translateService.currentLang === 'es'
                ? 'es_AR'
                : this._translateService.currentLang;

        this._unsubscribeAll = new Subject();
        this.user = _authenticationService.currentUserValue;
        this.showExtraToFields = false;

        this.filteredEmials = this.emailsCtrl.valueChanges.pipe(
            startWith(''),
            switchMap(() => {
                return this._dropdownsService.getUserEmails(
                    this.emailsCtrl.value
                );
            })
        );
        this.filteredTemplates = this.templatesCtrl.valueChanges.pipe(
            startWith(''),
            switchMap(() => {
                let type = 'properties_to_accounts';
                return this._dropdownsService.getEmailsTemplates(
                    this.templatesCtrl.value,
                    type
                );
            })
        );
        this.filter = {
            reference: '',
            _ids: ['5cc58754b15da737de08eac8', '5cc47f38b15da71900647a64'],
        };
    }

    ngOnInit(): void {
        this.filter._ids = this.data.selectedItems;

        let model = this.data.model ? this.data.model : 'properties';
        let fromEmail = this.user.user_email;
        if (this.user.mailbox_user && this.user.mailbox_user.username) {
            fromEmail = this.user.mailbox_user.username;
        }

        this.pdf = this.formBuilder.group({
            download: false,
            hd: false,
            email: true,
            model: model,
            properties_interested: { value: this.filter._ids, disabled: false },
            mail: this.formBuilder.group({
                to: '',
                files: '',
                from: { value: fromEmail, disabled: true },
                subject: '',
                content: '',
                cc: '',
                bcc: '',
                client: new UntypedFormControl({ value: '', disabled: false }),
                account: new UntypedFormControl({ value: '', disabled: false }),
                thumbnail: false,
                dell_bucket: new UntypedFormControl({
                    value: 'true',
                    disabled: false,
                }),
            }),
            wl: [],
        });

        this.pdf.get('mail.thumbnail').valueChanges.subscribe(() => {
            if (this.pdf.get('mail.thumbnail').value) {
                if (!this.pdf.get('mail.content').value) {
                    this.pdf.get('mail.content').setValue('');
                }
                if (
                    this.pdf
                        .get('mail.content')
                        .value.indexOf('[thumbnails_links') < 0 &&
                    this.currentLang === 'es_AR'
                ) {
                    this.pdf
                        .get('mail.content')
                        .setValue(
                            '[thumbnails_links lang=ES] <br> ' +
                                this.pdf.get('mail.content').value
                        );
                } else if (
                    this.pdf
                        .get('mail.content')
                        .value.indexOf('[thumbnails_links') < 0
                ) {
                    this.pdf
                        .get('mail.content')
                        .setValue(
                            '[thumbnails_links lang=EN] <br> ' +
                                this.pdf.get('mail.content').value
                        );
                }
            }
        });

        if (this.data.account && this.data.account._id) {
            this.pdf.get('mail.client').setValue(this.data.account._id);
            this.onClientSelect(this.data.account);
        }

        this.emailSearch$
            .pipe(
                debounceTime(200),
                startWith(''),
                tap(() => (this.loadingEmails = true)),
                takeUntil(this._unsubscribeAll),
                switchMap((search: string) => {
                    if (!search) {
                        search = '';
                    }
                    return this._dropdownsService.getUserEmails(search);
                })
            )
            .subscribe((data: any) => {
                this.emailsData = data;
                this.loadingEmails = false;
            });

        this.accountSearch$
            .pipe(
                startWith(''),
                debounceTime(200),
                tap(() => (this.loadingAccounts = true)),
                takeUntil(this._unsubscribeAll),
                switchMap((search: string) => {
                    if (!search) {
                        search = '';
                    }
                    return this._dropdownsService.getClientAccount(
                        search,
                        this.pdf.get('mail.client').value
                    );
                })
            )
            .subscribe((data: any) => {
                const accounts = map(data.body, (account) => {
                    account.label = account.reference;
                    if (account.forename && account.surname) {
                        account.label =
                            account.forename + ' ' + account.surname;
                    } else {
                        account.label = account.email;
                    }
                    return account;
                });
                this.accounts = accounts;
                this.loadingAccounts = false;
            });

        // this.pdf.get('mail.client').valueChanges
        // .subscribe(() => {
        //   this.pdf.get('mail.account').setValue(this.pdf.get('mail.client').value);
        // });

        this.propertySearch
            .pipe(
                startWith(''),
                tap(() => (this.searching = true)),
                switchMap((search: string) => {
                    this.filter.reference = search;
                    return this._dropdownsService.getPropertiesPDF(
                            this.filter
                        );
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.properties = data.body;
                this.filter = {};
            });
    }

    openTemplates(): void {
        const dialogRef = this._matDialog.open(PdfListDialogComponent, {
            panelClass: 'pdf-list-dialog',
            data: {
                viewRecord: true,
                properties: this.pdf.get('properties_interested').value,
                type: false,
            },
        });
        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                this.downloadFiles = response;
                if (response.names) {
                    this.attachments = _.concat(
                        this.attachments,
                        response.names
                    );
                }
            }
        });
    }

    loadSignature(): void {
        this.sign = 'primary';
        if (this._authenticationService.currentUserValue.signature) {
            if (this.pdf.get('mail.content').value && this.activeEditor) {
                this.activeEditor.insertContent(
                    this._authenticationService.currentUserValue.signature
                );
            } else {
                this.pdf
                    .get('mail.content')
                    .setValue(
                        this._authenticationService.currentUserValue.signature
                    );
            }
        }
    }
    addAccount(event): void {
        event.stopPropagation();
        const dialogRef = this._matDialog.open(QuickAddComponent, {
            panelClass: 'event-form-dialog',
            disableClose: false,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                this.pdf.get('mail.client').setValue(result._id);
                this.accountSearch$.next('');
                this.onClientSelect(result);
            });
    }
    previewEmail(): void {
        let data = {
            to: this.emails,
            // to: this.pdf.get('mail.to').value, // comment bcz it doesn't contains the updated value
            from: this.pdf.get('mail.from').value,
            subject: this.pdf.get('mail.subject').value,
            content: this.pdf.get('mail.content').value,
        };
        data['property_ids'] = this.pdf.get('properties_interested').value;
        
        this._matDialog.open(PreviewEmailComponent, {
            disableClose: true,
            panelClass: 'mail-preview-dialog',
            data: data,
        });
    }

    onClientSelect(account): void {
        if (account) {
            if (
                this.pdf.get('mail.to').value !== '' &&
                account.email &&
                account.email !== ''
            ) {
                let to = this.pdf.get('mail.to').value;
                if (to.indexOf(account.email) < 0) {
                    to = to + ',' + account.email;
                    this.pdf.get('mail.to').setValue(to.split(','));
                    this.emails.push(account.email);
                }
                this.pdf.get('mail.account').setValue(account._id);
            } else if (account.email && account.email !== '') {
                this.pdf.get('mail.to').setValue([account.email]);
                this.pdf.get('mail.account').setValue(account._id);
                this.emails.push(account.email);
            }
        }
    }

    setDownloadValue(e: any): void {
        if (e.checked && this.pdf.get('email').value) {
            this.pdf.get('email').setValue(false);
        }
        if (!e.checked && !this.pdf.get('email').value) {
            this.pdf.get('email').setValue(true);
        }
    }

    setEmailValue(e: any): void {
        if (e.checked && this.pdf.get('download').value) {
            this.pdf.get('download').setValue(false);
        }
        if (!e.checked && !this.pdf.get('download').value) {
            this.pdf.get('download').setValue(true);
        }
    }

    toggleExtraToFields(): void {
        this.showExtraToFields = !this.showExtraToFields;
    }

    add(event: MatChipInputEvent): void {
        const value = event.value;
        if ((value || '').trim()) {
            this.emails.push(value.trim());
        }
        // Clear the input value
        event.chipInput!.clear();
        
        this.emailsCtrl.setValue('');
    }

    onSelectEmail(event: MatAutocompleteSelectedEvent): void {
        this.emails.push(event.option.viewValue);
        this.emailInput.nativeElement.value = '';
        this.emailsCtrl.setValue('');
    }

    remove(fruit: string): void {
        const index = this.emails.indexOf(fruit);
        if (index >= 0) {
            this.emails.splice(index, 1);
        }
    }

    onSelectTemplate(event: any): void {
        this.pdf.get('mail.subject').setValue(event.subject);
        this.pdf.get('mail.content').setValue(event.content);
    }

    onSelectFile(files: FileList): void {
        const uploader = [];
        _.forEach(files, (file: File) => {
            uploader.push(this._attachmentsService.mailAttachment(file));
        });
        forkJoin(uploader)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (data: any) => {
                    const attachments = _.map(data, (url) =>
                        _.last(_.split(url, '/'))
                    );
                    this.attachments = _.concat(this.attachments, attachments);
                },
                () => {}
            );
    }

    closeDialog(action: string): void {
        const emails = _.map(this.emails, (e) => ({ email: e }));
        const dataObj = this.pdf.getRawValue();
        if (dataObj.mail) {
            dataObj.mail.to = emails;
            dataObj.mail.files = this.attachments;
        }
        if (action === 'send') {
            this._composeEmailsService
                .sendEmail(dataObj)
                .subscribe((result) => {
                    this._snackBar.open(
                        this._translateService.instant('Send successfully'),
                        this._translateService.instant('Close'),
                        {
                            duration: 2000,
                        }
                    );
                    this.dialogRef.close();
                    // this.router.navigate(['/properties/index']);
                });
        }
    }

    removeAttachment(file: any): void {
        _.remove(this.attachments, (el: any) => {
            return el === file;
        });
    }

    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    download(): void {
        this.downloadFiles.urls.forEach((element) => {
            window.open(element, '_blank');
        });

        // this.values = this._globalFunctions.cleanObject(this.pdf.value);
        // let add = {};
        // const data = {} as any;
        // if (!(this.pdf.get('hd').value)) {
        //   add = {
        //     hd: false
        //   };
        //   _.merge(this.values, add);
        // }
        // if (!(this.pdf.get('multipal_pdf').value)) {
        //   add = {
        //     multipal_pdf: false
        //   };
        //   _.merge(this.values, add);
        // }
        // add = {
        //   email: false
        // };
        // _.merge(this.values, add);
        // data.pdf = this.values;
        // data.dom_object = {};
        // this._propertiesService.generatePdf(data).subscribe((success: any) => {
        //   console.log(success);
        // });
    }
    focusOutFunction(): void {
        if (this.emailsCtrl.value) {
            this.emails.push(this.emailsCtrl.value);
            this.emailInput.nativeElement.value = '';
            this.emailsCtrl.setValue('');
        }
    }
}
